import type { CSSProperties, ReactNode } from "react"

import { cn } from "@/lib/utils"

interface ShieldFrameProps {
  children: ReactNode
  size?: number
  gradient?: string
  className?: string
}

const ASPECT = 1.25 // height = width * 1.25 (matches pennant shape)

export function ShieldFrame({
  children,
  size = 64,
  gradient = "linear-gradient(180deg, var(--surface-raised), var(--card))",
  className,
}: ShieldFrameProps) {
  const height = Math.round(size * ASPECT)

  return (
    <div
      className={cn(
        "flex items-center justify-center [clip-path:polygon(8%_0%,92%_0%,100%_8%,100%_85%,50%_100%,0%_85%,0%_8%)]",
        className,
      )}
      style={{ width: size, height, background: gradient } as CSSProperties}
    >
      {children}
    </div>
  )
}
